import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import App from './App'
import store from './store'
import { ThemeModeProvider } from './theme/ThemeModeProvider'
import './i18n'
import './register-sw'

const container = document.getElementById('root')
const root = createRoot(container)
const persistor = persistStore(store)

root.render(
  <Provider store={store}>
    <StrictMode>
      <ThemeModeProvider>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </ThemeModeProvider>
    </StrictMode>
  </Provider>
)